import React, { useState } from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu';
import Reschedulecomp from '../../Components/schedulePOComps/Reschedulecomp';
import Myprofile from '../myprofile/Myprofile';
import { useLocation } from 'react-router-dom';

const Reshedule = () => {

    const location = useLocation()

    const [data, setData] = useState(location.state)

    console.log("dat---", data)
    return (
        <>
            <Myprofile >

                <Reschedulecomp
                    data={data}
                />
            </Myprofile>


        </>
    )
}

export default Reshedule